import { Outlet } from "react-router";
import React from "react";
import RedesignNavChrome from "@layouts/RedesignNavChrome";
import Footer from "@pages/HomeRedesign/components/Footer/Footer";
import ScrollToTop from "@components/ScrollToTop/ScrollToTop";

export default function AppLayout() {
  return (
    <React.Fragment>
      <RedesignNavChrome />
      <ScrollToTop />
      <Outlet />
      <Footer />
    </React.Fragment>
  );
}
